(function () {
  function initSlider(track) {
    if (track.classList.contains('dp-icons') && window.innerWidth >= 750) {
      return; // en escritorio, los iconos no llevan autoplay ni se duplican
    }

    var speed = 1.2;
    var isPaused = false;

    // Esperamos a que todas las imágenes estén cargadas de verdad antes de arrancar
    var imgs = track.querySelectorAll('img');
    var loaded = 0;
    var total = imgs.length;

    function startWhenReady() {
      loaded++;
      if (loaded >= total) {
        start();
      }
    }

    if (total === 0) {
      start();
    } else {
      imgs.forEach(function (img) {
        if (img.complete) {
          startWhenReady();
        } else {
          img.addEventListener('load', startWhenReady);
          img.addEventListener('error', startWhenReady);
        }
      });
    }

    function start() {
      // Duplicar contenido una vez para el bucle continuo
      if (!track.dataset.dpDuplicated) {
        track.innerHTML += track.innerHTML;
        track.dataset.dpDuplicated = 'true';
      }

      var halfWidth = track.scrollWidth / 2;
      if (halfWidth <= track.clientWidth) {
        return; // no hay suficiente contenido para desplazar, no hacemos nada
      }

      setInterval(function () {
        if (isPaused) return;
        track.scrollLeft = track.scrollLeft + speed;
        if (track.scrollLeft >= halfWidth) {
          track.scrollLeft = 0;
        }
      }, 16);
    }

    track.addEventListener('mouseenter', function () { isPaused = true; });
    track.addEventListener('mouseleave', function () { isPaused = false; });
    track.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
    track.addEventListener('touchend', function () { isPaused = false; });
  }

  document.querySelectorAll('[data-dp-logos-slider]').forEach(initSlider);
})();